import PageLayout from "../components/pages/PageLayout";
import PageHero from "../components/pages/PageHero";
import FeatureGrid from "../components/pages/FeatureGrid";
import SplitSection from "../components/pages/SplitSection";
import StepsList from "../components/pages/StepsList";
import FaqList from "../components/pages/FaqList";
import RelatedLinks from "../components/pages/RelatedLinks";
import { SERVICE_PAGES } from "../content/servicePages";

export default function ServicePage({ path }) {
  const page = SERVICE_PAGES[path];
  return (
    <PageLayout testId={page.testId}>
      {(openContact) => (
        <>
          <PageHero {...page.hero} crumbs={page.crumbs} onContact={openContact} />
          <FeatureGrid {...page.features} light={path === "/services"} />
          <SplitSection {...page.split} />
          <StepsList {...page.steps} steps={page.steps.items} />
          <FaqList faqs={page.faqs} />
          <RelatedLinks paths={page.related} />
        </>
      )}
    </PageLayout>
  );
}
